import { BanksaladCardPromotionWithCalculation } from '@/page-src/chart/cards/pages/cashback/hooks/use-card-promotion-context';
import { DepositExtended } from '@/page-src/product/pages/deposits/api';
import {
  ClickMoreInfoButtonFinancialProductSearchDetail,
  ClickPromotionProduct,
  ClickPromotionProductDetailButton,
  ClickToChangeCalculationResult,
  ClickToEnterListFinancialProductSearchDetail,
  ExposePromotionProduct,
  ExposeViewFinancialProductSearchDetail,
  IssueProductFinancialProductSearchDetail,
} from '@/src/events/interfaces/product/deposits/product-guid';
import { sendTrackEvent } from '@/src/events/send-track-event';
import { EventName } from '@/src/events/types/event-name';
import { ProductDomainForEvent } from '@/src/events/types/product-domain';
import { ScreenName } from '@/src/events/types/screen-name';

export const trackExposeViewFinancialProductSearchDetail = (deposit: DepositExtended) => {
  const eventParam: ExposeViewFinancialProductSearchDetail = {
    event_type: EventName.EXPOSE_VIEW__FINANCIAL_PRODUCT_SEARCH_DETAIL,
    current_screen: ScreenName.FINANCIAL_PRODUCT_SEARCH_DETAIL,
    product_domain: ProductDomainForEvent.FIXED_DEPOSIT,
    object_id: deposit.productGuid,
    object_name: deposit.name,
    object_organization: deposit.organization.name,
    is_stopped: deposit.isStopped,
    is_exposable: deposit.isExposable,
  };
  sendTrackEvent<ExposeViewFinancialProductSearchDetail>({ eventParam });
};

export const trackIssueProductFinancialProductSearchDetail = (
  deposit: DepositExtended,
  location: 'fixed' | 'floating'
) => {
  const eventParam: IssueProductFinancialProductSearchDetail = {
    event_type: EventName.ISSUE__PRODUCT_FINANCIAL_PRODUCT_SEARCH_DETAIL,
    current_screen: ScreenName.FINANCIAL_PRODUCT_SEARCH_DETAIL,
    product_domain: ProductDomainForEvent.FIXED_DEPOSIT,
    object_id: deposit.productGuid,
    object_name: deposit.name,
    object_organization: deposit.organization.name,
    location,
  };
  sendTrackEvent<IssueProductFinancialProductSearchDetail>({ eventParam });
};

export const trackClickToChangeCalculationResult = (
  controlKeyGroup: '가입기간' | '금액' | '우대 조건'
) => {
  const eventParam: ClickToChangeCalculationResult = {
    event_type: EventName.CLICK_TO_CHANGE_CALCULATION_RESULT,
    current_screen: ScreenName.FINANCIAL_PRODUCT_SEARCH_DETAIL,
    product_domain: ProductDomainForEvent.FIXED_DEPOSIT,
    control_key_group: controlKeyGroup,
  };
  sendTrackEvent<ClickToChangeCalculationResult>({ eventParam });
};

export const trackClickToEnterListFinancialProductSearchDetail = (
  deposit: DepositExtended,
  location: 'floating' | 'fixed' | 'rank_section'
) => {
  const eventParam: ClickToEnterListFinancialProductSearchDetail = {
    event_type: EventName.CLICK_TO_ENTER_LIST__FINANCIAL_PRODUCT_SEARCH_DETAIL,
    current_screen: ScreenName.FINANCIAL_PRODUCT_SEARCH_DETAIL,
    product_domain: ProductDomainForEvent.FIXED_DEPOSIT,
    object_id: deposit.productGuid,
    object_name: deposit.name,
    object_organization: deposit.organization.name,
    location,
  };
  sendTrackEvent<ClickToEnterListFinancialProductSearchDetail>({ eventParam });
};

export const trackClickMoreInfoButtonFinancialProductSearchDetail = (isExpended: boolean) => {
  const eventParam: ClickMoreInfoButtonFinancialProductSearchDetail = {
    event_type: EventName.CLICK_MORE_INFO_BUTTON__FINANCIAL_PRODUCT_SEARCH_DETAIL,
    current_screen: ScreenName.FINANCIAL_PRODUCT_SEARCH_DETAIL,
    product_domain: ProductDomainForEvent.FIXED_DEPOSIT,
    is_expended: isExpended,
  };
  sendTrackEvent<ClickMoreInfoButtonFinancialProductSearchDetail>({ eventParam });
};

export const trackExposePromotionProduct = (
  card: BanksaladCardPromotionWithCalculation,
  index: number
) => {
  const eventParam: ExposePromotionProduct = {
    event_type: EventName.EXPOSE__PROMOTION_PRODUCT,
    current_screen: ScreenName.FINANCIAL_PRODUCT_SEARCH_DETAIL,
    product_domain: ProductDomainForEvent.FIXED_DEPOSIT,
    object_id: card.basicBanksaladCard?.id || '',
    object_name: card.basicBanksaladCard?.name || '',
    object_organization: card.cardCompany?.name || '',
    product_order: index,
  };
  sendTrackEvent<ExposePromotionProduct>({ eventParam });
};

export const trackClickPromotionProduct = (
  card: BanksaladCardPromotionWithCalculation,
  index: number
) => {
  const eventParam: ClickPromotionProduct = {
    event_type: EventName.CLICK__PROMOTION_PRODUCT,
    current_screen: ScreenName.FINANCIAL_PRODUCT_SEARCH_DETAIL,
    product_domain: ProductDomainForEvent.FIXED_DEPOSIT,
    object_id: card.basicBanksaladCard?.id || '',
    object_name: card.basicBanksaladCard?.name || '',
    object_organization: card.cardCompany?.name || '',
    product_order: index,
  };
  sendTrackEvent<ClickPromotionProduct>({ eventParam });
};

export const trackClickPromotionProductDetailButton = () => {
  const eventParam: ClickPromotionProductDetailButton = {
    event_type: EventName.CLICK_PROMOTION_PRODUCT_DETAIL_BUTTON,
    current_screen: ScreenName.FINANCIAL_PRODUCT_SEARCH_DETAIL,
    product_domain: ProductDomainForEvent.FIXED_DEPOSIT,
  };
  sendTrackEvent<ClickPromotionProductDetailButton>({ eventParam });
};
